import { useValidateTypescriptPropTypes, type ValidationMap } from '@elliemae/ds-props-helpers';
import { DSButtonName } from '../DSButtonDefinitions.js';
import type { DSButtonT } from '../react-desc-prop-types.js';

export const useValidateProps = (props: DSButtonT.Props, propTypes: ValidationMap<unknown>): void => {
  // we validate the "required if" via 'isRequiredIf from our custom PropTypes
  useValidateTypescriptPropTypes(props, propTypes, DSButtonName);

  if (props.size === 's')
    // eslint-disable-next-line no-console
    console.warn("[DSButton] Size 's' will be deprecated in the future, so its use is not recommended.");
};
